import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PreviousRouteService } from "../../global_services/PreviousRouteService";

@Injectable()
export class PreviousRouteGuard  {
  constructor(
    private router: Router,
    private previousRouteService: PreviousRouteService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const PrevRoute = this.previousRouteService.getPreviousUrl();
    if (PrevRoute === 'home' || PrevRoute === '') {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}
